import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { IBucketItem } from "../../models/bucket-item.model";
import { BucketItemService } from "../../service/bucket-item.service";
import { Subscription, catchError, map, throwError } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { IBreadcrumbItem } from "../../../../main/layout/tool-bar/model/breadcrumb.model";
import { ComponentConstants } from "../../constants/component-constants";
import { IBucketItemRequestForMove } from "../../models/bucket-item-list-request-move.model";
import { IDestinationPathResponse } from "../../models/destination-path-response.model";
import { MatButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatTable, MatColumnDef, MatCellDef, MatCell, MatRowDef, MatRow } from "@angular/material/table";

@Component({
    selector: "app-destination-path-dialog",
    templateUrl: "./destination-path-dialog.component.html",
    styleUrls: ["./destination-path-dialog.component.scss"],
    imports: [MatButton, MatTooltip, MatTable, MatColumnDef, MatCellDef, MatCell, MatRowDef, MatRow]
})
export class DestinationPathDialogComponent implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<DestinationPathDialogComponent>>(MatDialogRef);
  private activatedRoute = inject(ActivatedRoute);
  private bucketItemService = inject(BucketItemService);
  private sourceDirName = inject(MAT_DIALOG_DATA);

  public bucketItems: Partial<IBucketItem>[] = [];
  public columnList: string[] = ["ItemType", "Name"];
  public metaData: Partial<IBreadcrumbItem> = null;
  public breadCrumbData: string[] = [];
  public subscription: Subscription;
  public parentId: string = null;
  public currentDestinationPath: string = null;
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "move-items-destination-dialog";
  ngOnInit(): void {
    this.subscription = this.activatedRoute.queryParams.subscribe((x) => {
      this.metaData = {
        BucketId: x.bucketId,
        BucketType: x.bucketType,
        BUCode: x.buCode,
      };

      this.getBucketItems({
        BucketId: x.bucketId,
        BucketType: x.bucketType,
        BUCode: x.buCode,
        DirectoryName: x.directoryName,
        SourceDirectoryName: this.sourceDirName,
      });
    });
  }

  public getBucketItems(
    bucketItemRequest: IBucketItemRequestForMove,
    setDestinationPath: boolean = false
  ) {
    this.bucketItemService
      .GetBucketItemsForMove(bucketItemRequest)
      .pipe(
        map((response: any) => {
          this.bucketItems = [...response.BucketItems];
          this.parentId = response.ParentId;
          this.bucketItems.sort((a, b) =>
            a.Type > b.Type ? -1 : a.Type < b.Type ? 1 : 0
          );
          this.setBreadcrumbData(bucketItemRequest.DirectoryName);
          if (setDestinationPath) {
            this.currentDestinationPath = bucketItemRequest.DirectoryName;
          }
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error.message);
        })
      )
      .subscribe();
  }

  public setBreadcrumbData(directoryName: string) {
    this.breadCrumbData = [...directoryName.split("/").splice(1)];
  }

  public navigateToFolder(item: Partial<IBucketItem>) {
    this.navigate(`${item.DirName}/${item.LeafName}`);
  }

  public onCloseClick(destinationPath: string): void {
    if (destinationPath.length > 0 && this.currentDestinationPath) {
      var response: IDestinationPathResponse = {
        path: this.currentDestinationPath,
        id: this.parentId,
      };
      this.dialogRef.close(response);
    } else {
      this.dialogRef.close(null);
    }
  }

  public navigateFromBreadCrumb(index: number) {
    this.navigate(
      `${
        this.metaData.BUCode === ""
          ? ComponentConstants.BU_GLOBAL
          : this.metaData.BUCode
      }/${this.breadCrumbData.slice(0, index + 1).join("/")}`
    );
  }

  private navigate(dirPath: string) {
    this.getBucketItems(
      {
        BucketId: this.metaData.BucketId,
        BucketType: this.metaData.BucketType,
        BUCode: this.metaData.BUCode,
        DirectoryName: dirPath,
        SourceDirectoryName: this.sourceDirName,
      },
      true
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public buildControlId(element: string, indexOrState?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (indexOrState !== undefined && indexOrState !== null) {
      tokens.push(this.formatIndexSuffix(indexOrState));
    }
    return tokens.join('-');
  }

  private formatIndexSuffix(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    return this.slugify(value);
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }
}
